import React, { useState, useCallback, useEffect } from 'react';
import block from 'bem-cn';
import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';

import Select from 'components/Select/desktop';
import Button from 'components/Button';
import InputDate from 'components/InputDate/desktop';
import Input from 'components/Input';
import CheckBox from 'components/CheckBox';

import DaysFilter from 'features/reports/view/desktop/DaysFilter';
import { actions as treeActions } from 'features/tree';

import { actions } from 'features/reports/redux';

import './FilterBlock.scss';
import Modal from 'components/ModalProvider/Modal/Modal';
import CashbackTerms from 'features/users/view/desktop/Modals/CashbackTerms/CashbackTerms';
import { actions as authActions } from 'features/Auth/redux';

const b = block('filter-block-cashback-history-desktop');

const FilterBlock = ({ count, currentPage, onPageClick, setCashbackActionModal }) => {
  const locale = useSelector(state => state.locale.locale);
  const dispatch = useDispatch();
  const [isCashbackTermsModalOpen, setIsCashbackTermsModalOpen] = useState(false);
  const [date, setDate] = useState({
    beginDate: new Date(dayjs().add(-3, 'day').startOf('date')),
    endDate: new Date(dayjs().startOf('date')),
  });
  const [activeDay, setActiveDay] = useState('');
  const [filters, setFilters] = useState({
    user: '',
    id: '',
  });

  const onChangeBeginDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, beginDate: value });
    }
    setActiveDay('');
  };

  const onChangeEndDate = value => {
    if (!isNaN(value.valueOf())) {
      setDate({ ...date, endDate: value });
    }
  };

  const openCashbackTermsModal = () => {
    setIsCashbackTermsModalOpen(true);
  };

  const handleUserChange = useCallback(
    e => {
      setFilters({ ...filters, [e.currentTarget.name]: e.currentTarget.value });
    },
    [filters],
  );

  const handleSearch = useCallback(() => {
    const requestedData = {
      username: filters.user,
      id: filters.id,
      count,
      page: currentPage,
      ...date,
    };
    dispatch(actions.getCashbackHistory(requestedData));
  }, [count, currentPage, date, dispatch, filters.id, filters.user]);

  useEffect(() => {
    handleSearch();
  }, [count, currentPage]);

  useEffect(() => {
    dispatch(authActions.getCashbackInfo());
  }, []);

  const onClickSearch = () => {
    // filters.user.length > 0 && getTreeById(filters.user || '');
    handleSearch(true);
    // dispatch(treeActions.setSearchTree(filters.user));
    onPageClick(0);
  };

  // useEffect(() => {
  //   dispatch(treeActions.setSearchTree(''));
  // }, []);

  const onChangeActiveDay = useCallback(
    dayFilter => {
      setActiveDay(dayFilter);
      setDate({ ...date, beginDate: dayFilter.value, endDate: dayFilter.value2 });
    },
    [date],
  );

  return (
    <div className={b()}>
      <div className={b('header')}>{locale.filter}</div>
      <div className={b('top')}>
        <DaysFilter activeDay={activeDay} setActiveDay={onChangeActiveDay} />
        <div className={b('or')}>{locale.or}</div>
        <div className={b('date')}>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateFrom}</div>
            <div className={b('date-input')}>
              <InputDate selected={date.beginDate} onChange={onChangeBeginDate} />
            </div>
          </div>
          <div className={b('date-row')}>
            <div className={b('title')}>{locale.dateUntil}</div>
            <div className={b('date-input')}>
              <InputDate selected={date.endDate} onChange={onChangeEndDate} />
            </div>
          </div>
        </div>
      </div>

      <div className={b('bottom')}>
        <div className={b('inputs')}>
          <div className={b('input')}>
            <div className={b('title')}>{locale.id}</div>
            <Input size="low" value={filters.id} callBack={handleUserChange} placeholder={locale.id} name="id" />
          </div>

          <div className={b('input')}>
            <div className={b('title')}>{locale.username}</div>
            <Input size="low" value={filters.user} callBack={handleUserChange} placeholder={locale.id} name="user" />
          </div>
        </div>
        <div className={b('button-group')}>
          <div className={b('button')}>
            <Button
              color="green"
              size="low"
              callBack={() => setCashbackActionModal('activate')}
              text={<span className={b('button-text')}>{locale.activateCashback}</span>}
            />
          </div>
          <div className={b('button')}>
            <Button
              color="red"
              size="low"
              callBack={() => setCashbackActionModal('deactivate')}
              text={<span className={b('button-text')}>{locale.deactivateCashback}</span>}
            />
          </div>
          <div className={b('button')}>
            <Button
              color="transparent"
              size="low"
              callBack={openCashbackTermsModal}
              text={<span className={b('button-text')}>{locale.cashbackTerms}</span>}
            />
          </div>
          <div className={b('button', { big: true })}>
            <Button size="low" callBack={() => onClickSearch()} text={locale.acceptFilter} />
          </div>
        </div>
      </div>
      {isCashbackTermsModalOpen && (
        <Modal
          closeFunction={() => setIsCashbackTermsModalOpen(false)}
          content={<CashbackTerms closeFunction={() => setIsCashbackTermsModalOpen(false)} />}
        />
      )}
    </div>
  );
};

export default FilterBlock;
